export function common() {

  jQuery(function($){

    // タブレット表示
    var ua = navigator.userAgent;
    var viewport = document.querySelector("meta[name=viewport]");
    if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
        viewport.setAttribute("content", "width=device-width,initial-scale=1");
    } else {
        viewport.setAttribute("content", "width=1430");
    }

    // スマホtel link
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
      $('.tel').each(function() {
        var str = $(this).html();
        if ($(this).children().is('img')) {
            $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
        } else {
            $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
        }
      });
    }

    //正確なvhの取得
    /*-
    使い方: calc(var(--vh, 1vh) * 100);
    -*/
    function setHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setHeight();//初期化
    window.addEventListener('resize', setHeight);// 再計算


    //ブレイクポイント画像切り替え
    var $elem = $('.sp_img');
    var sp = '_sp.';
    var pc = '_pc.';
    var replaceWidth = 767; //ブレイクポイント指定

    function imageSwitch() {
      var windowWidth = parseInt($(window).width()); //ウィンドウサイズ取得
      $elem.each(function () {
          var $this = $(this);
          if (windowWidth >= replaceWidth) {
              $this.attr('src', $this.attr('src').replace(sp, pc));
          } else {
              $this.attr('src', $this.attr('src').replace(pc, sp));
          }
      });
    }
    imageSwitch();

    // リサイズの実行タイミング設定
    var delayStart;
    var delayTime = 200;
    $(window).on('resize', function () {
    clearTimeout(delayStart);
      delayStart = setTimeout(function () {
        imageSwitch();
      }, delayTime);
    });

    $(function() {
      // 切り替える対象にclass属性。
      var $elem = $('.switch');
      
      // 切り替えの対象のsrc属性の末尾の文字列。
      var sp = '_sp.';
      var pc = '_pc.';
      
      // 画像を切り替えるウィンドウサイズ。
      var replaceWidth = 768;
      
     function videoSwitch() {
      // ウィンドウサイズを取得する。
      var windowWidth = parseInt($(window).width());
    
     // ページ内にあるすべての`.switch`に適応される。
      $elem.each(function() {
      var $this = $(this);
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if(windowWidth >= replaceWidth) {
      $this.attr('data-src', $this.attr('data-src').replace(sp, pc));
    
     // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
      $this.attr('data-src', $this.attr('data-src').replace(pc, sp));
      }
      });
    }
     videoSwitch();
    
     // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
      var resizeTimer;
      $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
      videoSwitch();
      }, 200);
      });
    });


    //navi PC
    if (window.matchMedia('(min-width: 768px)').matches) {
      jQuery(function ($) {
          $('ul.menu li.menu-item').hover(function() {
              $(this).find('.sub-menu').stop().slideDown();
          }, function() {
              $(this).find('.sub-menu').stop().slideUp();
          });
      })
    }

    //navi sp
    if (window.matchMedia('(max-width: 1400px)').matches) {
      // 親メニュー処理
      $('.menu-item-has-children').click(function() {
        $(this).toggleClass('menu_open');
        // メニュー表示/非表示
        $(this).next('.sub-menu').slideToggle();
      });
      // 子メニュー処理
      $('.menu-item-has-children').click(function(e) {
          // メニュー表示/非表示
          $(this).children('.sub-menu').slideToggle();
          e.stopPropagation();
      });
    }

    //navi SP
    jQuery(function ($) {
      //bodyのスクロール位置の格納
      //var state = false;
      //var scrollpos;
      $('#toggle').click(function(){
          if($(this).hasClass('active')){
              $(this).removeClass('active');
              $('.l-header').removeClass('active');
              $('.l-header_navArea').fadeOut();
          }else{
              $(this).addClass('active');
              $('.l-header').addClass('active');
              $('.l-header_navArea').fadeIn().css({'display':'flex'});
          }
          /*
          if(state == false) {
            scrollpos = $(window).scrollTop()
            $('body').addClass('fixed').css({'top': -scrollpos})
            state = true;
          } else {
              $('body').removeClass('fixed').css({'top': 0}),
              window.scrollTo( 0 , scrollpos )
              state = false;
          }
          */
      });
      $('.menu-item > a').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              /*
              if(state == false) {
                scrollpos = $(window).scrollTop()
                $('body').addClass('fixed').css({'top': -scrollpos})
                state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
              */
          }
      });
      $('.nav_close').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              /*
              if(state == false) {
                  scrollpos = $(window).scrollTop()
                  $('body').addClass('fixed').css({'top': -scrollpos})
                  state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
              */
          }
      });
    });





    //ヘッダーの高さに連動
    function headerHeightSwitch() {
      var headerHeight = jQuery('.l-header').outerHeight(); //ウィンドウサイズ取得
      var footerHeight = jQuery('.l-footer').outerHeight(); //ウィンドウサイズ取得
      jQuery('.anchor').css({'padding-top': headerHeight});
      jQuery('.anchor').css({'margin-top': -headerHeight});
      jQuery('.section_spacer').css({'padding-top': headerHeight});
      jQuery('.section_spacer_wrap').css({'min-height': 'calc((980 / 1700 * 100vw) + ' + headerHeight+ 'px)'});
      jQuery('.section_spacer_inner').css({'height': 'calc(100dvh - ' + headerHeight+ 'px)'});
      jQuery('.section_spacer_inner_footer').css({'min-height': 'calc(100dvh - ' + headerHeight+ 'px - ' + footerHeight+ 'px)'});
      if (window.matchMedia('(min-width: 1631px)').matches) {
        jQuery('.section_spacer_wrap').css({'min-height': 'calc(980px + ' + headerHeight+ 'px)'});
      }
    }
    headerHeightSwitch();
    jQuery(window).on('resize', function () {
      headerHeightSwitch();
    });


    //js-scroll
    var wH = $(window).height();
    var EffectH = wH/6*1;
    jQuery(window).on('scroll load', function() {
      var scTop = $(this).scrollTop();
      var scBottom = scTop + $(this).height();
      var effectPos = scBottom - EffectH;
      jQuery('.js-scroll, .js-scroll-delay').each( function() {
        var thisPos = $(this).offset().top;
        if ( thisPos < effectPos ) {
          $.when(
            jQuery(this).addClass("show")
          ).done(function() {
            jQuery(this).delay(250).queue(function(){
                jQuery(this).addClass("done")
            })
          });
        }
      });
    });

    //ページトップ
    var pageTop = $('#pageTop');
    pageTop.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 650) {
        pageTop.fadeIn();
      } else {
        pageTop.fadeOut();
      }
    });
    pageTop.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 550);
      return false;
    });

    //スムーススクロール
    $('a[href^="#"]').click(function () {
      var speed = 550;
      var href = $(this).attr("href");
      //var headerHight = $('.l-header_inner').outerHeight();
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });

    //js-searchArea
    $('.js-searchArea button').hide();
    $('#input1_wrap.js-searchArea .js-searchArea_button').on('click', function(){
      if($(this).parents('.js-searchArea').hasClass('active')){
        if($('#input1').hasClass('not_entered')){
          $(this).parents('.js-searchArea').removeClass('active');
          $(this).prev('.js-searchArea_input').animate({width:'hide'});
        }else{
        }
      }else{
        $(this).parents('.js-searchArea').addClass('active');
        $(this).prev('.js-searchArea_input').animate({width:'toggle'});
      }
    });
    $('#input2_wrap.js-searchArea .js-searchArea_button').on('click', function(){
      if($(this).parents('.js-searchArea').hasClass('active')){
        if($('#input2').hasClass('not_entered')){
          $(this).parents('.js-searchArea').removeClass('active');
          $(this).prev('.js-searchArea_input').animate({width:'hide'});
        }else{
        }
      }else{
        $(this).parents('.js-searchArea').addClass('active');
        $(this).prev('.js-searchArea_input').animate({width:'toggle'});
      }
    });
    $(function() {
      var $input1 = $('#input1');
      var $input2 = $('#input2');
      var $button1 = $('#button1');
      var $button2 = $('#button2');
      //var $output1 = $('#output1');
      //var $output2 = $('#output2');
      $input1.on('input', function(event) {
        var value = $input1.val();
        //$output1.text(value);
        $input1.addClass('entered');
        $input1.removeClass('not_entered');
        $button1.children('.icon').hide();
        $button1.children('button').show();
        if($input1.val() === ""){
          //$output1.text("not_entered");
          $input1.removeClass('entered');
          $input1.addClass('not_entered');
          $button1.children('.icon').show();
          $button1.children('button').hide();
        }
      });
      
      $input1.on('change', function(event) {
        //$output2.text($input1.val());
        $input1.addClass('entered');
        $input1.removeClass('not_entered');
        $button1.children('.icon').hide();
        $button1.children('button').show();
        if($input1.val() === ""){
          //$output2.text("not_entered");
          $input1.removeClass('entered');
          $input1.addClass('not_entered');
          $button1.children('.icon').show();
          $button1.children('button').hide();
        }
      });

      $input2.on('input', function(event) {
        var value = $input2.val();
        //$output1.text(value);
        $input2.addClass('entered');
        $input2.removeClass('not_entered');
        $button2.children('.icon').hide();
        $button2.children('button').show();
        if($input2.val() === ""){
          //$output1.text("not_entered");
          $input2.removeClass('entered');
          $input2.addClass('not_entered');
          $button2.children('.icon').show();
          $button2.children('button').hide();
        }
      });
      
      $input2.on('change', function(event) {
        //$output2.text($input2.val());
        $input2.addClass('entered');
        $input2.removeClass('not_entered');
        $button2.children('.icon').hide();
        $button2.children('button').show();
        if($input2.val() === ""){
          //$output2.text("not_entered");
          $input2.removeClass('entered');
          $input2.addClass('not_entered');
          $button2.children('.icon').show();
          $button2.children('button').hide();
        }
      });
    });


  });//jQuery

  //SplitType
  const text = new SplitType(".c-splitText");

  //missionVideo
  const missionVideo = document.querySelector('#missionVideo');
  if(missionVideo) {
    var video = document.getElementById("missionVideo");
    function setVideoPosition() {
      video.currentTime = 5; //再生位置
    }
    setVideoPosition()
  }


  const loader = document.querySelector('#loader');
  if(loader) {
    window.addEventListener('load', () => {
      const loader = document.querySelector('#loader');
      loader.classList.add('loaded');
      setTimeout(function() {
        loader.classList.add('loaded');
      }, 5000);
    });
  }



  //ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);
  
  const indexAnime = document.querySelector('.p-indexAnime');
  if(indexAnime) {
    gsap.from(".p-indexAnime .progress", {
      scrollTrigger: {
        trigger: ".p-indexAnime",
        scrub: true,
        start: "top", // アニメーション開始位置
        end: "+=8000", // アニメーション終了位置
      },
      scaleX: 0,
      transformOrigin: "left top",
      ease: "none"
    });
    gsap.timeline({
      defaults: {
        duration: 300
      },
      scrollTrigger: {
        trigger: '.p-indexAnime',
        start: 'top', // 開始する位置
        end: '+=8000',// 終了する位置
        scrub: true,
        pin: true,
        //markers: true,
      }
    })
      .to(".p-indexAnime #hero", { autoAlpha: 0, delay: 600 })
      //service
      .to(".p-indexAnime .p-indexService_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'})
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_01", { autoAlpha: 0}, "<")
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_01", { autoAlpha: 0, y: 20}, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_01", { autoAlpha: 1})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_01", { autoAlpha: 1, y: 0}, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_01", { autoAlpha: 0,delay:600})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_01", { autoAlpha: 0,y:-20}, "<")
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_02", { autoAlpha: 0})
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_02", { autoAlpha: 0, y: 20 }, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_02", { autoAlpha: 1})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_02", { autoAlpha: 1,y:0}, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_02", { autoAlpha: 0,delay:600})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_02", { autoAlpha: 0,y:-20}, "<")
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_03", { autoAlpha: 0})
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_03", { autoAlpha: 0, y: 20 }, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_03", { autoAlpha: 1})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_03", { autoAlpha: 1,y:0}, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_03", { autoAlpha: 0,delay:600})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_03", { autoAlpha: 0,y:-20}, "<")
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_04", { autoAlpha: 0})
      .from(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_04", { autoAlpha: 0, y: 20 }, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_04", { autoAlpha: 1})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_04", { autoAlpha: 1,y:0}, "<")
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_txt_04", { autoAlpha: 0,delay:600})
      .to(".p-indexAnime .p-indexService_cont .p-indexService_cont_img_04", { autoAlpha: 0,y:-20}, "<")
      .to(".p-indexAnime .p-indexService_cont_mainttl", { opacity: 0}, "<")
      //aboutus
      .fromTo(".p-indexAnime #aboutus", { autoAlpha: 0 },{ autoAlpha: 1 })
      .fromTo(".p-indexAnime .p-indexAboutus_inner_mainttl .mainttl_line_01", { scale: 0,transformOrigin: "left" },{ scale: 1 })
      .to(".p-indexAnime .p-indexAboutus_inner_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'}, "<")
      .fromTo(".p-indexAnime .p-indexAboutus_inner_mainttl .mainttl_line_02", { scale: 0,transformOrigin: "left" },{ scale: 1, delay: 100 }, "<")
      .from(".p-indexAnime .p-indexAboutus_cont_txt", { autoAlpha: 0}, "<")
      .from(".p-indexAnime .p-indexAboutus_cont_img", { autoAlpha: 0, y: 20 }, "<")
      .to(".p-indexAnime .p-indexAboutus_cont_txt", { autoAlpha: 1})
      .to(".p-indexAnime .p-indexAboutus_cont_img", { autoAlpha: 1,y: 0}, "<")
      .to(".p-indexAnime .p-indexAboutus_cont_txt", { autoAlpha: 0,delay:600})
      .to(".p-indexAnime .p-indexAboutus_cont_img", { autoAlpha: 0,y: -20}, "<")
      .to(".p-indexAnime #aboutus",{ autoAlpha: 0 }, "<")
      //mission
      .fromTo(".p-indexAnime #mission", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-indexAnime .p-indexMission_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'}, "<")
      .fromTo(".p-indexAnime .p-indexMission_cont_txt", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-indexAnime #mission",{ autoAlpha: 0,delay:600})
      //access
      .fromTo(".p-indexAnime #access", { autoAlpha: 0 },{ autoAlpha: 1 })
      .fromTo(".p-indexAnime .p-indexAccess_bg", { scale: 0,transformOrigin: "bottom" },{ scale: 1,duration: 1000 }, "<")
      .to(".p-indexAnime .p-indexAccess_info_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out',delay:450}, "<")
      .fromTo(".p-indexAnime .p-indexAccess_info_box", { autoAlpha: 0 },{ autoAlpha: 1,delay:500 }, "<")
  }
  

  //mission
  const missionAnime = document.querySelector('.p-missionAnime');
  if(missionAnime) {
    gsap.from(".p-missionAnime .progress", {
      scrollTrigger: {
        trigger: ".p-missionAnime",
        scrub: true,
        start: "top", // アニメーション開始位置
        end: "+=7000", // アニメーション終了位置
      },
      scaleX: 0,
      transformOrigin: "left top",
      ease: "none"
    });
    gsap.timeline({
      defaults: {
        duration: 300
      },
      scrollTrigger: {
        trigger: '.p-missionAnime',
        start: 'top', // 開始する位置
        end: '+=7000',// 終了する位置
        scrub: true,
        pin: true,
        //markers: true,
      }
    })
      //lead
      //.fromTo(".p-missionAnime .p-missionAnime_movie", { autoAlpha: 0 },{ autoAlpha: 1,duration: 2000 })
      .to(".p-missionAnime .p-missionLead_cont_txt_01_01", { autoAlpha: 0, delay:600}, "<")
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_01_02", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_01_02", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_01_03", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_01_03", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_01_04", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_01_04", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_01_05", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_01_05", { autoAlpha: 0, delay:600})
      .to(".p-missionAnime #lead .p-missionLead", { autoAlpha: 0})
      //vision
      .fromTo(".p-missionAnime #vision .p-missionLead", { autoAlpha: 0 },{ autoAlpha: 1 }, "<")
      .to(".p-missionAnime #vision .p-missionLead_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_02_01", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_02_01", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_02_02", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_02_02", { autoAlpha: 0, delay:600})
      .to(".p-missionAnime #vision .p-missionLead", { autoAlpha: 0})
      //value
      .fromTo(".p-missionAnime #value .p-missionLead", { autoAlpha: 0 },{ autoAlpha: 1 }, "<")
      .to(".p-missionAnime #value .p-missionLead_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_03_01", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_03_01", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_03_02", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to(".p-missionAnime .p-missionLead_cont_txt_03_02", { autoAlpha: 0, delay:600})
      .fromTo(".p-missionAnime .p-missionLead_cont_txt_03_03", { autoAlpha: 0 },{ autoAlpha: 1 })
  
  }
  

  //member
  const memberAnime = document.querySelector('.p-memberAnime');
  if(memberAnime) {
    gsap.from(".p-memberAnime .progress", {
      scrollTrigger: {
        trigger: ".p-memberAnime",
        scrub: true,
        start: "top", // アニメーション開始位置
        end: "+=7000", // アニメーション終了位置
      },
      scaleX: 0,
      transformOrigin: "left top",
      ease: "none"
    });
    gsap.timeline({
      defaults: {
        duration: 300
      },
      scrollTrigger: {
        trigger: '.p-memberAnime',
        start: 'top', // 開始する位置
        end: '+=7000',// 終了する位置
        scrub: true,
        pin: true,
        //markers: true,
      }
    })
      //lead
      
      .to(".p-memberAnime .txt_01", { autoAlpha: 0, delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_01", { autoAlpha: 0, y: -20}, "<")

      .from(".p-memberAnime .txt_02", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_02", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_02", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_02", { autoAlpha: 1,y:0}, "<")
      .to(".p-memberAnime .txt_02", { autoAlpha: 0,delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_02", { autoAlpha: 0,y:-20}, "<")

      .from(".p-memberAnime .txt_03", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_03", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_03", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_03", { autoAlpha: 1,y:0}, "<")
      .to(".p-memberAnime .txt_03", { autoAlpha: 0,delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_03", { autoAlpha: 0,y:-20}, "<")

      .from(".p-memberAnime .txt_04", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_04", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_04", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_04", { autoAlpha: 1,y:0}, "<")
      .to(".p-memberAnime .txt_04", { autoAlpha: 0,delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_04", { autoAlpha: 0,y:-20}, "<")

      .from(".p-memberAnime .txt_05", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_05", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_05", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_05", { autoAlpha: 1,y:0}, "<")
      .to(".p-memberAnime .txt_05", { autoAlpha: 0,delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_05", { autoAlpha: 0,y:-20}, "<")

      .from(".p-memberAnime .txt_06", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_06", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_06", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_06", { autoAlpha: 1,y:0}, "<")
      .to(".p-memberAnime .txt_06", { autoAlpha: 0,delay:600})
      .to(".p-memberAnime .p-memberLead_cont_img_06", { autoAlpha: 0,y:-20}, "<")

      .from(".p-memberAnime .txt_07", { autoAlpha: 0 })
      .from(".p-memberAnime .p-memberLead_cont_img_07", { autoAlpha: 0, y: 20}, "<")
      .to(".p-memberAnime .txt_07", { autoAlpha: 1})
      .to(".p-memberAnime .p-memberLead_cont_img_07", { autoAlpha: 1,y:0}, "<")
  }

  //consulting
  const consultingAnime = document.querySelector('.p-consultingAnime');
  if(consultingAnime) {
    gsap.from(".p-consultingAnime .progress", {
      scrollTrigger: {
        trigger: ".p-consultingAnime",
        scrub: true,
        start: "top", // アニメーション開始位置
        end: "+=4000", // アニメーション終了位置
      },
      scaleX: 0,
      transformOrigin: "left top",
      ease: "none"
    });
    gsap.timeline({
      defaults: {
        duration: 300
      },
      scrollTrigger: {
        trigger: '.p-consultingAnime',
        start: 'top', // 開始する位置
        end: '+=4000',// 終了する位置
        scrub: true,
        pin: true,
        //markers: true,
      }
    })
      //achievements
      .to("#achievements .c-point_cont_txt_01", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_02", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_02", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_03", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_03", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_04", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_04", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_05", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_05", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_06", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_06", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_07", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_07", { autoAlpha: 0, delay:600})
      .fromTo("#achievements .c-point_cont_txt_08", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#achievements .c-point_cont_txt_08", { autoAlpha: 0, delay:600})
      .to("#achievements .c-point_cont_img_01", { autoAlpha: 0, y: -20}, "<")
      .to("#achievements .c-point_cont_mainttl", {autoAlpha: 0}, "<")
      .to("#achievements", { autoAlpha: 0})
      //assistance
      .fromTo("#assistance", { autoAlpha: 0 },{ autoAlpha: 1 }, "<")
      .to("#assistance .p-consultingTxt_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'}, "<")
      .to("#assistance", { autoAlpha: 0, delay:600})
      //advertisement
      .fromTo("#advertisement", { autoAlpha: 0 },{ autoAlpha: 1 })
      .to("#advertisement .p-consultingTxt_cont_mainttl .char", {y: 0,stagger: 50,duration: 300,ease: 'power2.out'}, "<")
  }

  //sns
  const supportAnime = document.querySelector('.p-snsAnime');
  if(supportAnime) {
    gsap.from(".p-snsAnime .progress", {
      scrollTrigger: {
        trigger: ".p-snsAnime",
        scrub: true,
        start: "top", // アニメーション開始位置
        end: "+=4000", // アニメーション終了位置
      },
      scaleX: 0,
      transformOrigin: "left top",
      ease: "none"
    });
    gsap.timeline({
      defaults: {
        duration: 300
      },
      scrollTrigger: {
        trigger: '.p-snsAnime',
        start: 'top', // 開始する位置
        end: '+=4000',// 終了する位置
        scrub: true,
        pin: true,
        //markers: true,
      }
    })
      //achievements
      .to("#features .c-point_cont_txt_01", { autoAlpha: 0, delay:600})
      .from("#features .c-point_cont_txt_02", { autoAlpha: 0 })
      .to("#features .c-point_cont_txt_02", { autoAlpha: 1})
      .to("#features .c-point_cont_txt_02", { autoAlpha: 0,delay:600})
      .to("#features .c-point_cont_img_01", { autoAlpha: 0,y:-20}, "<")

      .from("#features .c-point_cont_txt_03", { autoAlpha: 0 })
      .from("#features .c-point_cont_img_02", { autoAlpha: 0, y: 20}, "<")
      .to("#features .c-point_cont_txt_03", { autoAlpha: 1})
      .to("#features .c-point_cont_img_02", { autoAlpha: 1,y:0}, "<")
      .to("#features .c-point_cont_txt_03", { autoAlpha: 0,delay:600})
      .from("#features .c-point_cont_txt_04", { autoAlpha: 0 })
      .to("#features .c-point_cont_txt_04", { autoAlpha: 1})
      .to("#features .c-point_cont_txt_04", { autoAlpha: 0,delay:600})
      .to("#features .c-point_cont_img_02", { autoAlpha: 0,y:-20}, "<")

      .from("#features .c-point_cont_txt_05", { autoAlpha: 0 })
      .from("#features .c-point_cont_img_03", { autoAlpha: 0, y: 20}, "<")
      .to("#features .c-point_cont_txt_05", { autoAlpha: 1})
      .to("#features .c-point_cont_img_03", { autoAlpha: 1,y:0}, "<")
      .to("#features .c-point_cont_txt_05", { autoAlpha: 0,delay:600})
      .from("#features .c-point_cont_txt_06", { autoAlpha: 0 })
      .to("#features .c-point_cont_txt_06", { autoAlpha: 1})
      .to("#features .c-point_cont_txt_06", { autoAlpha: 0,delay:600})
      .from("#features .c-point_cont_txt_07", { autoAlpha: 0 })
      .to("#features .c-point_cont_txt_07", { autoAlpha: 1})
      .to("#features .c-point_cont_txt_07", { autoAlpha: 0,delay:600})
      .to("#features .c-point_cont_img_03", { autoAlpha: 0,y:-20}, "<")

      .from("#features .c-point_cont_txt_08", { autoAlpha: 0 })
      .from("#features .c-point_cont_img_04", { autoAlpha: 0, y: 20}, "<")
      .to("#features .c-point_cont_txt_08", { autoAlpha: 1})
      .to("#features .c-point_cont_img_04", { autoAlpha: 1,y:0}, "<")
      .to("#features .c-point_cont_txt_08", { autoAlpha: 0,delay:600})
      .from("#features .c-point_cont_txt_09", { autoAlpha: 0 })
      .to("#features .c-point_cont_txt_09", { autoAlpha: 1})
  }



}
